import { render, staticRenderFns } from "./LProjectConfigurationComments.vue?vue&type=template&id=5a662dc7&scoped=true&"
import script from "./LProjectConfigurationComments.vue?vue&type=script&lang=js&"
export * from "./LProjectConfigurationComments.vue?vue&type=script&lang=js&"
import style0 from "./LProjectConfigurationComments.vue?vue&type=style&index=0&id=5a662dc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a662dc7",
  null
  
)

export default component.exports